import {Option} from 'platform/components';

import {isNotNil} from 'ramda';
import {isFalse, isNilOrEmpty} from 'ramda-adjunct';

import {useGetCustomTenantCatalogueQuery} from '@dms/api/sales';

import {Nullish} from 'shared/web';

type ModelOption = {
  make: string;
  makeLabel: string;
} & Option;

export function useCustomTenantCatalogue(
  vehicleType: string | Nullish,
  makes?: string[] | Nullish
) {
  const {
    data: customTenantCatalogue,
    isLoading,
    isError,
  } = useGetCustomTenantCatalogueQuery(undefined, {skip: isNilOrEmpty(vehicleType)});

  const customMakes =
    isNotNil(customTenantCatalogue) && vehicleType
      ? customTenantCatalogue?.[vehicleType]?.makes
      : null;
  const customMakesKeys = customMakes ? Object.keys(customMakes) : null;

  const filteredCustomMakesKeys = customMakesKeys // eslint-disable-line no-nested-ternary -- Pre-existing violation
    ? makes && makes.length > 0
      ? customMakesKeys.filter((make) => makes.includes(make))
      : customMakesKeys
    : null;

  const customMakeOptions =
    customMakes && filteredCustomMakesKeys
      ? filteredCustomMakesKeys.reduce((makesAcc: Option[], make) => {
          if (!customMakes[make] || isFalse(customMakes[make]?.isCustom)) {
            return makesAcc;
          }
          return [...makesAcc, {label: make, value: make}];
        }, [])
      : null;

  const customModelOptions =
    customMakes && filteredCustomMakesKeys
      ? filteredCustomMakesKeys.reduce((models: ModelOption[], make) => {
          if (!customMakes[make]) {
            return models;
          }
          const options = Object.keys(customMakes[make].models)
            .filter((model) => customMakes[make].models[model].isCustom)
            .map((model) => ({
              label: model,
              value: model,
              makeLabel: make,
              make,
            }));

          return [...models, ...options];
        }, [])
      : null;

  return {customMakeOptions, customModelOptions, isLoading, isError};
}
